var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01158 13.6678L5.01167 13.6679C5.2217 13.8813 5.5061 14 5.804 14C6.1019 14 6.3863 13.8813 6.59633 13.6679L6.59637 13.6679L17.1763 2.91746C17.6079 2.47904 17.6079 1.77054 17.1763 1.33211C16.7405 0.889295 16.0295 0.889296 15.5937 1.33211L15.9429 1.67592L15.5937 1.33211L5.804 11.2776L2.40633 7.82585C1.97045 7.38303 1.25955 7.38303 0.823666 7.82585L1.17682 8.17347L0.823666 7.82585C0.392111 8.26427 0.392111 8.97277 0.823666 9.4112L5.01158 13.6678Z",
    fill: "#00A90B",
    stroke: "#00A90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.7e75e06a794e981387ed64d1d80db635.svg";
export { ForwardRef as ReactComponent };